import { gql } from '@apollo/client'

export const GET_CUSTOM_AIR_FRESHENER = gql`
  {
    products(first: 1, query: "title:'Custom Air Freshener'") {
      edges {
        node {
          id
          title
          options {
            name
            values
          }
          variants(first: 100) {
            edges {
              node {
                id
                title
              }
            }
          }
        }
      }
    }
  }
`